:host([variant="large"]) {
  display: inline-block;
  --uui-spinner-size: 160px;
  min-width: var(--uui-spinner-size);
  min-height: var(--uui-spinner-size);
  width: var(--uui-spinner-size);
  height: var(--uui-spinner-size);
  --uui-spinner-dot-background: var(--uui-theme-secondary-400);
  --uui-spinner-color-1: var(--uui-theme-secondary-400);
  --uui-spinner-color-2: var(--uui-theme-variant-300);
  --uui-spinner-color-3: var(--uui-theme-on-core-300);
  --uui-spinner-color-4: var(--uui-theme-tertiary-900);
  --uui-spinner-animation-time: 8s;
  --uui-spinner-base-dot-size: 16px;
  --uui-spinner-base-dot-offset: 2px;
  --uui-spinner-margin: 10px;
  --uui-spinner-dot3-offset: calc(var(--uui-spinner-base-dot-offset) - 5px);
  --uui-spinner-dot2-size: calc(
    var(--uui-spinner-base-dot-size) * 1.25
  ); /* 20px */
  --uui-spinner-dot3-size: calc(
    var(--uui-spinner-base-dot-size) * 1.625
  ); /* 26px */
  --uui-spinner-dot4-size: var(--uui-spinner-base-dot-size); /* 16px */
  --uui-spinner-dot1-pattern-size: calc(
    var(--uui-spinner-base-dot-size) * 1.25
  ); /* 20px */
  --uui-spinner-dot2-pattern-size: calc(
    var(--uui-spinner-base-dot-size) * 1.75
  ); /* 28px */
  --uui-spinner-dot3-pattern-size: calc(
    var(--uui-spinner-base-dot-size) * 2.375
  ); /* 38px */
  --uui-spinner-dot4-pattern-size: calc(
    var(--uui-spinner-base-dot-size) * 3.25
  ); /* 52px */
}

.loading {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 100%;
  height: 100%;
}

.slot-container {
  /* margin-top: calc(var(--uui-spinner-size) / 2); */
  width: 100%;
  display: flex;
  justify-content: center;
}

.animation {
  flex: 1;
  position: relative;
  --offset-margin: calc(-1 * var(--uui-spinner-margin));
  transform: translate3d(var(--offset-margin), var(--offset-margin), 0);
  margin-left: 50%;
}

.dot,
.dot2,
.dot3,
.dot4 {
  position: absolute;
  border-radius: 50%;
}

.dot {
  left: var(--uui-spinner-base-dot-offset);
  top: var(--uui-spinner-base-dot-offset);
  width: var(--uui-spinner-base-dot-size);
  height: var(--uui-spinner-base-dot-size);
  background: var(--uui-spinner-dot-background);
  animation: spin var(--uui-spinner-animation-time) 0s infinite both;
}

.dot2 {
  width: var(--uui-spinner-dot2-size);
  height: var(--uui-spinner-dot2-size);
  background: var(--uui-spinner-color-3);
  animation: spin2 var(--uui-spinner-animation-time) 0s infinite both;
}

.dot3 {
  width: var(--uui-spinner-dot3-size);
  height: var(--uui-spinner-dot3-size);
  top: var(--uui-spinner-dot3-offset);
  left: var(--uui-spinner-dot3-offset);
  background: var(--uui-spinner-color-4);
  opacity: 0;
  animation: spin3 var(--uui-spinner-animation-time) 0s infinite both;
}

.dot4 {
  left: var(--uui-spinner-base-dot-offset);
  top: var(--uui-spinner-base-dot-offset);
  width: var(--uui-spinner-dot4-size);
  height: var(--uui-spinner-dot4-size);
  background: var(--uui-spinner-color-4);
  animation: spin4 var(--uui-spinner-animation-time) 0s infinite both;
}

@keyframes spin {
  0%,
  50% {
    box-shadow: 0 0 0 var(--uui-spinner-color-2),
      0 0 0 var(--uui-spinner-color-2), 0 0 0 var(--uui-spinner-color-2),
      0 0 0 var(--uui-spinner-color-2), 0 0 0 var(--uui-spinner-color-2),
      0 0 0 var(--uui-spinner-color-2), 0 0 0 var(--uui-spinner-color-2),
      0 0 0 var(--uui-spinner-color-2);
  }

  25% {
    transform: rotate(180deg);
  }

  12.5%,
  37.5% {
    --size: var(--uui-spinner-dot2-pattern-size);
    --neg-size: calc(-1 * var(--size));
    --color: var(--uui-spinner-color-2);
    box-shadow: var(--size) 0 0 var(--color),
      var(--neg-size) 0 0 var(--color), 0 var(--size) 0 var(--color),
      0 var(--neg-size) 0 var(--color);
  }

  50% {
    transform: rotate(360deg);
  }

  62.5%,
  95% {
    --size: var(--uui-spinner-dot1-pattern-size);
    --neg-size: calc(-1 * var(--size));
    --size2: var(--uui-spinner-dot2-pattern-size);
    --neg-size2: calc(-1 * var(--size2));
    --color: var(--uui-spinner-color-2);

    box-shadow: var(--size2) 0 0 var(--color),
      var(--neg-size2) 0 0 var(--color), 0 var(--size2) 0 var(--color),
      0 var(--neg-size2) 0 var(--color),
      var(--size) var(--neg-size) 0 var(--color),
      var(--size) var(--size) 0 var(--color),
      var(--neg-size) var(--neg-size) 0 var(--color),
      var(--neg-size) var(--size) 0 var(--color);
  }

  75% {
    transform: rotate(180deg);
  }
}

@keyframes spin2 {
  0% {
  }

  0%,
  50% {
    box-shadow: 0 0 0 var(--uui-spinner-color-3),
      0 0 0 var(--uui-spinner-color-3), 0 0 0 var(--uui-spinner-color-3),
      0 0 0 var(--uui-spinner-color-3), 0 0 0 var(--uui-spinner-color-3),
      0 0 0 var(--uui-spinner-color-3), 0 0 0 var(--uui-spinner-color-3),
      0 0 0 var(--uui-spinner-color-3);
  }

  25% {
    transform: rotate(-180deg);
  }

  12.5%,
  37.5% {
    --size: var(--uui-spinner-dot3-pattern-size);
    --size2: var(--uui-spinner-dot4-pattern-size);
    --neg-size: calc(-1 * var(--size));
    --neg-size2: calc(-1 * var(--size2));
    --color: var(--uui-spinner-color-3);

    box-shadow: var(--size2) 0 0 var(--color), var(--neg-size2) 0 0 var(--color),
      0 var(--size2) 0 var(--color), 0 var(--neg-size2) 0 var(--color),
      var(--size) var(--neg-size) 0 var(--color),
      var(--size) var(--size) 0 var(--color),
      var(--neg-size) var(--neg-size) 0 var(--color),
      var(--neg-size) var(--size) 0 var(--color);

    background: transparent;
  }

  50% {
    transform: rotate(-360deg);
  }

  62.5%,
  95% {
    --size: var(--uui-spinner-dot4-pattern-size);
    --neg-size: calc(-1 * var(--size));
    --color: var(--uui-spinner-color-3);
    box-shadow: var(--size) 0 0 var(--color), var(--neg-size) 0 0 var(--color),
      0 var(--size) 0 var(--color), 0 var(--neg-size) 0 var(--color);
    background: transparent;
  }

  75% {
    transform: rotate(-180deg);
  }
}

@keyframes spin3 {
  0%,
  50% {
    opacity: 0;
  }

  25% {
    transform: rotate(-180deg);
  }

  50% {
    transform: rotate(-360deg);
  }

  62.5%,
  95% {
    --size: var(--uui-spinner-dot3-pattern-size);
    --neg-size: calc(-1 * var(--size));
    --color: var(--uui-spinner-color-4);
    box-shadow: var(--size) var(--neg-size) 0 var(--color),
      var(--size) var(--size) 0 var(--color),
      var(--neg-size) var(--neg-size) 0 var(--color),
      var(--neg-size) var(--size) 0 var(--color);
    opacity: 1;
  }

  75% {
    transform: rotate(-180deg);
  }

  100% {
    opacity: 0;
  }
}

@keyframes spin4 {
  0%,
  50% {
    opacity: 0;
  }

  25% {
    transform: rotate(180deg);
  }

  12.5%,
  37.5% {
    --size: var(--uui-spinner-dot1-pattern-size);
    --neg-size: calc(-1 * var(--size));
    --color: var(--uui-spinner-color-4);
    box-shadow: var(--size) var(--neg-size) 0 var(--color),
      var(--size) var(--size) 0 var(--color),
      var(--neg-size) var(--neg-size) 0 var(--color),
      var(--neg-size) var(--size) 0 var(--color);
    opacity: 1;
  }

  50% {
    transform: rotate(360deg);
  }
}
